var $5f431994f708535e$exports = {};
$5f431994f708535e$exports = {
  "dragDescriptionKeyboard": "Prima Enter para iniciar o arrasto.",
  "dragDescriptionKeyboardAlt": "Prima Alt + Enter para iniciar o arrasto.",
  "dragDescriptionLongPress": "Prima longamente para come\xE7ar a arrastar.",
  "dragDescriptionTouch": "Fa\xE7a duplo toque para come\xE7ar a arrastar.",
  "dragDescriptionVirtual": "Clique para iniciar o arrasto.",
  "dragItem": function dragItem(args) {
    return "Arrastar ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Arrastar ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " item selecionado");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " itens selecionados");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Prima Enter para arrastar ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " o item selecionado");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " os itens selecionados");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Prima Alt + Enter para arrastar ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " o item selecionado");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " os itens selecionados");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Prima longamente para arrastar ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " o item selecionado");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " os itens selecionados");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Arrasto iniciado. Prima a tecla de tabula\xE7\xE3o para navegar para um destino para largar, e em seguida prima Enter para largar ou prima Escape para cancelar.",
  "dragStartedTouch": "Arrasto iniciado. Navegue para um destino para largar, e em seguida fa\xE7a duplo toque para largar.",
  "dragStartedVirtual": "Arrasto iniciado. Navegue para um destino para largar, e em seguida clique ou prima Enter para largar.",
  "dropCanceled": "Largar cancelado.",
  "dropComplete": "Largar completo.",
  "dropDescriptionKeyboard": "Prima Enter para largar. Prima Escape para cancelar o arrasto.",
  "dropDescriptionTouch": "Fa\xE7a duplo toque para largar.",
  "dropDescriptionVirtual": "Clique para largar.",
  "dropIndicator": "Indicador de largar",
  "dropOnItem": function dropOnItem(args) {
    return "Largar em ".concat(args.itemText);
  },
  "dropOnRoot": "Largar em",
  "endDragKeyboard": "A arrastar. Prima Enter para cancelar o arrasto.",
  "endDragTouch": "A arrastar. Fa\xE7a duplo toque para cancelar o arrasto.",
  "endDragVirtual": "A arrastar. Clique para cancelar o arrasto.",
  "insertAfter": function insertAfter(args) {
    return "Inserir depois de ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Inserir antes de ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Inserir entre ".concat(args.beforeItemText, " e ").concat(args.afterItemText);
  }
};
export { $5f431994f708535e$exports as default };